





import React from "react";
import { Container } from "reactstrap";

export default function PageHeader() {
  return (
    <div className="page-header header-filter">
      <div className="squares square1" />
      <div className="squares square2" />
      <div className="squares square3" />
      <div className="squares square4" />
      <div className="squares square5" />
      <div className="squares square6" />
      <div className="squares square7" />
      <div className="squareOverlap-A" />
      <Container>
        <div className="content-center brand">
          <h1 className="h1-seo">PROJ • HR</h1>
          <h3 className="d-none d-sm-block">
            Simplify( "Job-Search" )
          </h3>
          <h4>Still Under Construction</h4>
        </div>
      </Container>
    </div>
  );
}
